import React, {PureComponent} from 'react'

export class ContentLoader extends PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const {width, height} = this.props;
		const style = {width, height};

		return (
			<div className='placeholder-shimmer' style={style}/>
		)
	}
}
